module.exports = __webpack_public_path__ + "static/media/amex_logo.9bb32c48.png";